import React from 'react'
import { Layout, Typography, Col } from 'antd'
import MobileHeader from '../components/Partner/MobileHeader/MobileHeader'
import { authScreen } from '../translates'

const { Content } = Layout
const { Title, Text } = Typography

export default function NotFoundScreen () {
  return (
    <Layout className='Auth'>
      <MobileHeader />
      <Layout>
        <Content>
          <Col>
            <Title level={4}>{authScreen.title}</Title>
            <Text style={{ fontSize: '20px' }}>К сожалению, ссылка больше не действительна.</Text>
          </Col>
        </Content>
      </Layout>
    </Layout>
  )
}
